// extracted by mini-css-extract-plugin
export default {"past-orders--container":"PastOrdersContainer_past-orders--container__cm8Ae","past-orders--header":"PastOrdersContainer_past-orders--header__fRQR0"};